/* Copyright Information: Created by BuyGroup */
import { intersection } from "lodash";
import moment from "moment";

export function isArrayWithLength(arr) {
  return Array.isArray(arr) && arr.length;
}

export function getAllowedRoutes(routes) {
  const roles = JSON.parse(localStorage.getItem("role"));
  return routes.filter(({ permission }) => {
    if (!permission) return true;
    else if (!isArrayWithLength(permission)) return true;
    else return intersection(permission, roles).length;
  });
}

export function isLoggedIn() {
  if (localStorage.getItem("token") === null) {
    return false;
  } else return true;
}

// Format phone number
export const formatPhoneNumber = (phoneNumberString) => {
  if (!phoneNumberString) return "";
  if (phoneNumberString.includes("(")) return phoneNumberString;
  var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? "+1 " : "";
    return intlCode + "(" + match[2] + ") " + match[3] + "-" + match[4];
  }
  return phoneNumberString;
};

// Format date
export const formatDate = (date) => {
  return moment(date).format("MM/DD/YYYY");
};

// Format address
export const formatAddress = (street, city, state, zip_code) => {
  return street + ", " + city + ", " + state + ", " + zip_code;
};
/* Copyright Information: Created by BuyGroup */
